/**
 * Application-wide constants
 */

// Search and UI delays
export const SEARCH_DEBOUNCE_MS = 500;

// Pagination defaults
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 50];
